<script setup lang="ts">
import { onMounted, onUnmounted, onUpdated, ref, watch } from 'vue';
import { utilsMixins } from '@/mixins/utils.mixins';

import type { ProductGroupFabricsProducts } from '../../models/product-group-fabric-products.model';

interface Props {
  productGroupFabricProducts: ProductGroupFabricsProducts;
  showRemoveAllButton: boolean;
  showTotals: boolean;
}

const props = defineProps<Props>();

let productGroupFabricProducts = props.productGroupFabricProducts;
let stickyOffset = ref(0);

const emit = defineEmits<{
  removeAllQuantities: [];
}>();

watch(
  () => props.productGroupFabricProducts,
  function () {
    productGroupFabricProducts = props.productGroupFabricProducts;
  },
);

onMounted(() => {
  window.addEventListener('resize', calculateSitckyOffsetValue);
  calculateSitckyOffsetValue();
});

onUpdated(() => {
  calculateSitckyOffsetValue();
});

onUnmounted(() => {
  window.removeEventListener('resize', calculateSitckyOffsetValue);
});

function removeAllQuantities() {
  emit('removeAllQuantities');
}

function calculateSitckyOffsetValue() {
  const stickyDomElementIds = ['addEditNavBar', 'matrixRelatedOrdersSelector', 'quantitiesNavBar'];
  stickyOffset.value = utilsMixins.calculateDivHeight(stickyDomElementIds);
}
</script>
<template>
  <div class="product-group-header" :style="`top: ${stickyOffset}px`">
    <div class="title" v-on:click="productGroupFabricProducts.collapsed = !productGroupFabricProducts.collapsed">
      {{ productGroupFabricProducts.productGroup.name }}
      <span class="icon ico-arrow-down" :class="[{ collapsed: productGroupFabricProducts.collapsed }]"> </span>
    </div>
    <div v-if="showRemoveAllButton" class="remove-items icon ico-delete" v-on:click="removeAllQuantities"></div>
    <div v-if="showTotals" class="product-group-total">
      {{ productGroupFabricProducts.total }}
    </div>
  </div>
</template>
<style lang="scss">
.product-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: var(--primary-bg-color);
  border-bottom: 1px solid var(--border-color-new);
  border-top: 1px solid var(--border-color-new);
  position: sticky;
  z-index: 2;

  .title {
    padding-left: 12px;
    display: flex;
    align-items: center;
    position: relative;
    flex: 1;
    cursor: pointer;
    background-color: var(--primary-bg-color);

    .ico-arrow-down {
      width: 17px;
      margin: 5px 5px 5px 9px;
      transform: rotate(180deg);
      transition: 0.2s ease-in;

      &.collapsed {
        transition: 0.2s ease-in;
        transform: rotate(0deg);
      }
    }
  }

  .remove-items {
    margin: 0 24px;
    cursor: pointer;
  }

  .product-group-total {
    width: 80px;
    background-color: var(--bg-remark-selected-color);
    line-height: 50px;
  }

  @media (max-width: 1000px) {
    .title {
      padding: 0 10px;

      &:before {
        left: 2.5px;
      }
    }

    .product-group-total {
      width: 55px;
    }
  }

  @include breakpoint(medium) {
    .product-group-total {
      width: 35px;
    }
  }
}
</style>
